module.exports = __webpack_public_path__ + "img/dsc-5287.91ac17fc.jpg";